export default __webpack_public_path__ + "static/media/baby-3.83c8ed23.svg";